import { render } from "./OrderComment.vue?vue&type=template&id=3ebd9236&ts=true"
import script from "./OrderComment.vue?vue&type=script&lang=ts"
export * from "./OrderComment.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\BuildAgent\\work\\330398ee0e098db7\\LoadingSokoldok\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__